module.exports = __webpack_public_path__ + "img/check-mark.f5b3e850.jpg";